export const STAKING_ABI = [
  // User Functions - UPDATED: Now takes USD amounts
  "function registerAndStake(uint256 _planId, uint256 _usdAmount, uint256 _referrerId) external",
  "function stake(uint256 _planId, uint256 _usdAmount) external",
  "function withdrawROI(uint256 _investmentIndex) external",
  "function withdrawCapital(uint256 _investmentIndex) external",
  "function claimReferral() external", // NEW: claim vested direct-referral commission
  
  // NEW: USD-Token Conversion Functions
  "function usdToTokens(uint256 _usdAmount) external view returns (uint256)",
  "function tokensToUsd(uint256 _tokenAmount) external view returns (uint256)",
  "function getTokenPrice() external view returns (uint256)",
  "function previewTokenAmount(uint256 _usdAmount) external view returns (uint256)",
  "function previewUsdAmount(uint256 _tokenAmount) external view returns (uint256)",
  
  // View Functions - Some return USD amounts now
  "function calculateROI(uint256 _userId, uint256 _investmentIndex) external view returns (uint256)",
  "function getUserInfo(uint256 _userId) external view returns (address, uint256, address, uint256, uint256, uint256, uint256, uint256, bool, bool)",
  "function getUserInvestments(uint256 _userId) external view returns (tuple(uint256,uint256,uint256,uint256,uint256,bool,bool)[])",
  "function getUserIncomeBreakdown(uint256 _userId) external view returns (uint256, uint256, uint256, uint256)",
  "function getUserActivities(uint256 _userId, uint256 _limit) external view returns (tuple(uint256,uint256,uint256,uint256,uint8,uint256)[])",
  "function getPlanInfo(uint256 _planId) external view returns (tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,bool,bool,bool))",
  "function getSystemStats() external view returns (uint256, uint256, uint256, uint256)",
  "function getUserIdByAddress(address _user) external view returns (uint256)",
  "function getUserAddressById(uint256 _userId) external view returns (address)",
  
  // RANK/ACHIEVEMENT FUNCTIONS
  "function getAchievementLevel(uint256 _userId) external view returns (uint8)",
  "function getLevelStatistics(uint8 _level) external view returns (uint256, uint256)",
  "function getUsersByLevel(uint8 _level) external view returns (uint256[])",
  "function getUserLevelCount(uint256 _userId, uint256 _level) external view returns (uint256)",
  "function getTotalTeamCount(uint256 _userId) external view returns (uint256)",
  "function getLevelMembers(uint256 _userId, uint256 _level, uint256 _offset, uint256 _limit) external view returns (uint256[], uint256)",
  "function getTeamBreakdown(uint256 _userId) external view returns (uint256[20], uint256[20], uint256, uint256)",
  
  // REFERRAL REQUIREMENT FUNCTIONS
  "function getReferralRequirementStatus(uint256 _userId) external view returns (bool, uint256, uint256, uint256, bool)",

  // NEW: RIA (Recurring Income Activation / Retopup) + REFERRAL VESTING
  // getRIAStatus returns RIAStatusView: (riaModeActive, riaOccurred, riaCount, accumulatedForRIA, packageCost, entryThreshold, totalIncomeEarned)
  "function getRIAStatus(uint256 _userId) external view returns (tuple(bool,bool,uint256,uint256,uint256,uint256,uint256))",
  // getUserExtra: (firstInvestmentAmount, firstPlanId, lastReferralTime, totalBlacklistedTime)
  "function getUserExtra(uint256 _userId) external view returns (uint256, uint256, uint256, uint256)",
  // getReferralVests returns ReferralVest[]: (totalAmount, claimedAmount, startTime)
  "function getReferralVests(uint256 _userId) external view returns (tuple(uint256,uint256,uint256)[])",
  "function claimableReferral(uint256 _userId) external view returns (uint256)",
  "function riaThresholdMultiplier() external view returns (uint256)",
  "function riaReferralPercent() external view returns (uint256)",
  "function REFERRAL_VEST_MONTHS() external view returns (uint256)",

  // Public state variables - UPDATED
  "function addressToId(address) external view returns (uint256)",
  "function totalPlans() external view returns (uint256)",
  "function totalUsers() external view returns (uint256)",
  "function owner() external view returns (address)",
  "function admin() external view returns (address)",
  "function trailToken() external view returns (address)",
  "function tokenPrice() external view returns (uint256)", // CHANGED: was coinPrice
  "function promotionalRewardsEnabled() external view returns (bool)",
  "function defaultReferrerId() external view returns (uint256)",
  "function levelCommissions(uint256) external view returns (uint256)",
  "function plans(uint256) external view returns (tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,bool,bool,bool))",
  "function userIdExists(uint256) external view returns (bool)",
  // NOTE: users()/usersById() are now `internal` in the contract (no public getter).
  // Use getUserInfo(), getUserExtra(), getUserAddressById() and getRIAStatus() instead.
  "function userIncomes(uint256) external view returns (uint256, uint256, uint256, uint256)",
  
  // Array access functions
  "function allUsers(uint256) external view returns (address)",
  "function allUserIds(uint256) external view returns (uint256)",
  "function blacklistedUsers(uint256) external view returns (uint256)",
  
  // Mapping access functions
  "function levelUsers(uint256, uint256) external view returns (address)",
  "function levelMembers(uint256, uint256, uint256) external view returns (uint256)",
  "function userActivities(uint256, uint256) external view returns (tuple(uint256,uint256,uint256,uint256,uint8,uint256))",
  
  // Admin Functions - UPDATED
  "function blacklistUser(uint256 _userId, bool _status) external",
  "function updatePlanROI(uint256 _planId, uint256 _newROI) external",
  "function updateReferralCommission(uint256 _planId, uint256 _newCommission) external",
  "function toggleUserROI(uint256 _userId, bool _enabled) external",
  "function updateTokenPrice(uint256 _newPriceInUsd) external", // CHANGED: was updateCoinPrice
  "function togglePromotionalRewards(bool _enabled) external",
  "function togglePlanEligibility(uint256 _planId, bool _requiresReferrals) external",
  "function updateLevelCommission(uint256 _level, uint256 _percentage) external",
  "function togglePlan(uint256 _planId, bool _isActive) external", // NEW: enable/disable a plan for new joins
  "function setRiaReferralPercent(uint256 _percent) external", // NEW: editable RIA referral %
  "function setRiaThresholdMultiplier(uint256 _multiplier) external", // NEW: editable RIA entry multiplier
  "function emergencyWithdraw(address _token, uint256 _amount) external",
  "function transferOwnership(address _newOwner) external",
  "function setAdmin(address _newAdmin) external",
  "function getBlacklistedUsers() external view returns (uint256[])",
  
  // Events - UPDATED: Now include both USD and token amounts
  "event UserRegistered(address indexed user, uint256 indexed userId, uint256 indexed referrerId)",
  "event Staked(address indexed user, uint256 indexed userId, uint256 planId, uint256 usdAmount, uint256 tokenAmount)",
  "event ROIWithdrawn(address indexed user, uint256 indexed userId, uint256 planId, uint256 usdAmount, uint256 tokenAmount)",
  "event CapitalWithdrawn(address indexed user, uint256 indexed userId, uint256 planId, uint256 usdAmount, uint256 tokenAmount)",
  "event ReferralReward(address indexed referrer, uint256 indexed referrerId, address indexed referee, uint256 refereeId, uint256 usdAmount, uint256 tokenAmount)",
  "event LevelReward(address indexed user, uint256 indexed userId, uint256 level, uint256 usdAmount, uint256 tokenAmount, uint256 fromUserId)",
  "event AchievementUpdated(address indexed user, uint256 indexed userId, uint8 level)",
  "event UserBlacklisted(uint256 indexed userId, bool status)",
  "event TokenPriceUpdated(uint256 newPrice)",
  "event PlanToggled(uint256 indexed planId, bool isActive)", // NEW
  "event RIAModeActivated(uint256 indexed userId)", // NEW
  "event RIATriggered(uint256 indexed userId, uint256 retopupUsd, uint256 riaCount)", // NEW
  "event ReferralVested(uint256 indexed referrerId, uint256 totalUsdAmount, uint256 fromUserId)", // NEW
  "event ReferralClaimed(address indexed referrer, uint256 indexed referrerId, uint256 usdAmount, uint256 tokenAmount)" // NEW
];

export const ERC20_ABI = [
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function balanceOf(address account) external view returns (uint256)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function decimals() external view returns (uint8)",
  "function symbol() external view returns (string)",
  "function name() external view returns (string)",
  "function totalSupply() external view returns (uint256)",
  "function transfer(address to, uint256 amount) external returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) external returns (bool)",
  
  // Events
  "event Transfer(address indexed from, address indexed to, uint256 value)",
  "event Approval(address indexed owner, address indexed spender, uint256 value)"
];